import { Helmet } from 'react-helmet';
import i18n from 'i18next';

import UENav from '../components/UENav';
import UEHeroSection from '../components/UEHeroSection';
import UEBenefitsSection from '../components/UEBenefitsSection';
import UEProcessSection from '../components/UEProcessSection';
import UECompensationSection from '../components/UECompensationSection';
import UECtaSection from '../components/UECtaSection';
import UEFaqSection from '../components/UEFaqSection';
import SignUpSection from '../components/SignUpSection';
import UEFooter from '../components/UEFooter';
import '../styles/UberEatsPartnership.css';

// The page has no language route, so it picks the English NL texts itself.
const LANGUAGE = 'nl_en';
// The Flink <> Uber Eats opening, with Amsterdam, Groningen and Rotterdam in its city list.
const FOUNTAIN_URL = 'https://web.fountain.com/apply/flink/opening/test-uber-nl-rider-amsterdam';
// Tags every application from this page as an Uber Eats one.
const FORM_PARAMS = { utm_term: 'uberlpapply' };

const UberEatsPartnership = () => {
  if (i18n.language !== LANGUAGE) i18n.changeLanguage(LANGUAGE);

  return (
    <div className="ue-page">
      <Helmet>
        <title>
          Flink × Uber Eats — Ride with a Flink contract. Deliver with Uber Eats. | Amsterdam,
          Groningen and Rotterdam
        </title>
        <meta
          name="description"
          content="Become a Flink employee delivering exclusively for Uber Eats in Amsterdam, Groningen and Rotterdam. Real employment contract, full Dutch social security, weekly payroll, 100% of tips, plus a km bonus on every shift."
        />
        <meta property="og:title" content="Ride with a Flink contract. Deliver with Uber Eats." />
        <meta
          property="og:description"
          content="An employed rider role in Amsterdam, Groningen and Rotterdam — exclusive to the Flink × Uber Eats partnership."
        />
        <meta property="og:type" content="website" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <UENav />
      <UEHeroSection />
      <UEBenefitsSection />
      <UEProcessSection />
      <UECompensationSection />
      <UECtaSection />
      <SignUpSection formParams={FORM_PARAMS} fountainURL={FOUNTAIN_URL} frameScrolls />
      <UEFaqSection />
      <UEFooter />
    </div>
  );
};

export default UberEatsPartnership;
